/**
 * Copyright (c) 2025 Adaptive Chaos Labs, LLC
 * All rights reserved.
 */

import api from './api';
import type { ReusablePixel } from '../types';

export const pixelService = {
  async listPixels(): Promise<ReusablePixel[]> {
    const { data } = await api.get<ReusablePixel[]>('/api/pixels');
    return data ?? [];
  },

  async createPixel(pixel: Partial<ReusablePixel>): Promise<ReusablePixel> {
    const { data } = await api.post<ReusablePixel>('/api/pixels', pixel);
    return data;
  },

  async updatePixel(id: string, pixel: Partial<ReusablePixel>): Promise<ReusablePixel> {
    const { data } = await api.put<ReusablePixel>(`/api/pixels/${id}`, pixel);
    return data;
  },

  async deletePixel(id: string): Promise<void> {
    await api.delete(`/api/pixels/${id}`);
  },

  async togglePixel(id: string, enabled: boolean): Promise<ReusablePixel> {
    const { data } = await api.put<ReusablePixel>(`/api/pixels/${id}`, {
      enabled,
    });
    return data;
  },

  /**
   * Update the `visibility` of a pixel (admin-only operation).
   */
  async setVisibility(id: string, visibility: ReusablePixel['visibility']): Promise<ReusablePixel> {
    const { data } = await api.put<ReusablePixel>(`/api/pixels/${id}`, {
      visibility,
    });
    return data;
  },
};
